import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { formatDistance } from 'date-fns';
import { Task } from '@/lib/api/task';

export function TaskInfo({
  task,
  boxNames = {},
}: {
  task?: Task;
  boxNames?: Record<string, string>;
}) {
  return (
    <Card className="overflow-hidden h-fit" x-chunk="dashboard-05-chunk-4">
      <CardHeader className="flex flex-row items-start bg-muted/50">
        <div className="grid gap-0.5">
          <CardTitle className="group flex items-center gap-2 text-lg">
            Task {task?.id}
          </CardTitle>
          <CardDescription>
            Started{' '}
            {task?.task_initiated_date
              ? formatDistance(task.task_initiated_date, new Date(), {
                  addSuffix: true,
                })
              : '--'}
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent className="p-6 text-sm">
        <div className="grid gap-3">
          <div className="font-semibold">Task info</div>
          <ul className="grid gap-3">
            <li className="flex items-center justify-between">
              <span className="text-muted-foreground">Command</span>
              <span>{task?.task_command || '--'}</span>
            </li>
            <li className="flex items-center justify-between">
              <span className="text-muted-foreground">Status</span>
              <span>{task?.status || '--'}</span>
            </li>
            <li className="flex flex-col items-left justify-between">
              <span className="text-muted-foreground mb-2">Targets</span>
              <div className="flex gap-2 flex-wrap">
                {task?.boxes?.map((ip: string) => (
                  <Badge variant="outline" key={ip}>
                    {boxNames[ip] ? `${boxNames[ip]} (${ip})` : ip}
                  </Badge>
                ))}
              </div>
            </li>
          </ul>
        </div>
      </CardContent>
      <CardFooter className="flex flex-row items-center border-t bg-muted/50 px-6 py-3">
        <div className="text-xs text-muted-foreground">
          Completed{' '}
          {task?.task_completed_date
            ? formatDistance(task.task_completed_date, new Date(), {
                addSuffix: true,
              })
            : '--'}
        </div>
      </CardFooter>
    </Card>
  );
}
